import { render } from "./NoteCreate.vue?vue&type=template&id=47c1ad48&scoped=true"
import script from "./NoteCreate.vue?vue&type=script&lang=js"
export * from "./NoteCreate.vue?vue&type=script&lang=js"

import "./NoteCreate.vue?vue&type=style&index=0&id=47c1ad48&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c1ad48"]])

export default __exports__